"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module ChainApi
 */
var helpers_1 = require("../helpers");
var chain_1 = require("./model/chain");
var ApiModule_1 = require("../modules/ApiModule");
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["subscribePendingTransactions"] = "subscribePendingTransactions";
    SubscriptionType["subscribeBlockApplied"] = "subscribeBlockApplied";
    SubscriptionType["general"] = "general";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
var Subscription = /** @class */ (function () {
    function Subscription(type, callback) {
        this.type = type;
        this.callback = callback;
    }
    return Subscription;
}());
exports.Subscription = Subscription;
var ChainApi = /** @class */ (function (_super) {
    __extends(ChainApi, _super);
    function ChainApi(apiConnector, chainStore) {
        var _this = _super.call(this, {}) || this;
        _this._apiConnector = apiConnector;
        _this._chainStore = chainStore;
        return _this;
    }
    Object.defineProperty(ChainApi.prototype, "chainId", {
        get: function () {
            return helpers_1.dcorejs_lib.ChainConfig.networks.decent.chain_id;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Generates random sequence of bytes
     */
    ChainApi.generateNonce = function () {
        return helpers_1.dcorejs_lib.TransactionHelper.unique_nonce_uint64();
    };
    ChainApi.setupChain = function (chainId, chainConfig) {
        chainConfig.networks.decent = {
            chain_id: chainId
        };
    };
    /**
     * Fetches data from blockchain with given chain methods.
     *
     * Returns Promise.all with resolve result as array of results
     * in order of adding into ChainMethod
     *
     * @param {ChainMethods} methods
     * @return {Promise<any[]>}
     */
    ChainApi.prototype.fetch = function () {
        var _this = this;
        var methods = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            methods[_i] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            _this.connect()
                .then(function (res) {
                var commands = methods.map(function (method) { return helpers_1.dcorejs_lib.FetchChain(method.name, method.parameters); });
                Promise.all(commands)
                    .then(function (result) { return resolve(result); })
                    .catch(function (err) {
                    reject(_this.handleError(chain_1.ChainError.command_execution_failed, err));
                });
            })
                .catch(function (err) {
                reject(_this.handleError(chain_1.ChainError.api_connection_failed, err));
            });
        });
    };
    ChainApi.prototype.subscribe = function (callback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.connect()
                .then(function (res) {
                _this._chainStore.subscribe(callback);
                resolve(new Subscription(SubscriptionType.general, callback));
            })
                .catch(function (err) {
                if (process.env.ENVIRONMENT === 'DEV') {
                    console.log("debug => " + err);
                }
                reject(_this.handleError(chain_1.ChainError.api_connection_failed, err));
            });
        });
    };
    /**
     * @param callback  Callback method to handle subscription data.
     */
    ChainApi.prototype.subscribePendingTransactions = function (callback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.connect()
                .then(function (res) {
                _this._chainStore.subscribePendingTransaction(callback);
                resolve(new Subscription(SubscriptionType.subscribePendingTransactions, callback));
            })
                .catch(function (err) {
                if (process.env.ENVIRONMENT === 'DEV') {
                    console.log("debug => " + err);
                }
                reject(_this.handleError(chain_1.ChainError.api_connection_failed, err));
            });
        });
    };
    /**
     * @param callback  Callback method to handle subscription data.
     */
    ChainApi.prototype.subscribeBlockApplied = function (callback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.connect()
                .then(function (res) {
                _this._chainStore.subscribeBlockApplied(callback);
                resolve(new Subscription(SubscriptionType.subscribeBlockApplied, callback));
            })
                .catch(function (err) {
                if (process.env.ENVIRONMENT === 'DEV') {
                    console.log("debug => " + err);
                }
                reject(_this.handleError(chain_1.ChainError.api_connection_failed, err));
            });
        });
    };
    ChainApi.prototype.unsubscribe = function (subscription) {
        switch (subscription.type) {
            case SubscriptionType.general: {
                return this._chainStore.unsubscribe(subscription.callback);
            }
            case SubscriptionType.subscribeBlockApplied: {
                return this._chainStore.unsubscribeBlockApplied(subscription.callback);
            }
            case SubscriptionType.subscribePendingTransactions: {
                return this._chainStore.unsubscribePendingTransaction(subscription.callback);
            }
            default:
                return false;
        }
    };
    ChainApi.prototype.connect = function () {
        var _this = this;
        return new Promise((function (resolve, reject) {
            _this._apiConnector
                .connection()
                .then(function () {
                _this._chainStore.init()
                    .then(function () { return resolve(); })
                    .catch(function (err) { return reject(err); });
            })
                .catch(function (err) { return reject(err); });
        }));
    };
    ChainApi.asset = 'DCT';
    ChainApi.asset_id = '1.3.0';
    ChainApi.DCTPower = Math.pow(10, 8);
    return ChainApi;
}(ApiModule_1.ApiModule));
exports.ChainApi = ChainApi;
//# sourceMappingURL=chain.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/api/chain.js
// module id = 18
// module chunks = 0